export class StringUtil {
  static checkPositionDifferent(value, value2) {
    let positionPointer = -1;
    value = value || '';
    value2 = value2 || '';
    for (var i = 0; i < value2.length; i++) {
      if (value.charAt(i) !== value2.charAt(i)) {
        positionPointer = i;
        i = value2.length + 1;
      } 
    }
    return positionPointer;
  }
}
